import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-image-list-preview',
  templateUrl: './image-list-preview.component.html',
  styleUrls: ['./image-list-preview.component.scss']
})
export class ImageListPreviewComponent implements OnInit {
  @Input() images: string[] = [];
  isModalOpen = false;
  selectedImage: string | null = null;
  // If the actual file ends in .jpeg:
  // private fallbackImage = 'assets/images/1.jpg';
  constructor() { }

  ngOnInit() {
    // const existingImages = this.images || [];
    // this.images = [this.fallbackImage].concat(existingImages);

  }


  openModal() {
    this.isModalOpen = true;
    // Automatically select the first image as the main preview if available
    if (this.images && this.images.length > 0) {
      this.selectedImage = this.images[0];
    }
  }

  closeModal() {
    this.isModalOpen = false;
    this.selectedImage = null;
  }

  selectImage(url: string) {
    this.selectedImage = url;
  }

}
